/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_Credentials_DescInputs */

const es_prompt_tips_credentials_desc = /** @type {(inputs: Prompt_Tips_Credentials_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si buscás datos por mail, indicá la casilla exacta. Si es por ownership, mencioná el usuario. Esto evita ambigüedades y acelera la búsqueda.`)
};

const en_prompt_tips_credentials_desc = /** @type {(inputs: Prompt_Tips_Credentials_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If searching by email, specify the exact mailbox. If by ownership, mention the user. This avoids ambiguity and speeds up the search.`)
};

/**
* | output |
* | --- |
* | "If searching by email, specify the exact mailbox. If by ownership, mention the user. This avoids ambiguity and speeds up the search." |
*
* @param {Prompt_Tips_Credentials_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_credentials_desc = /** @type {((inputs?: Prompt_Tips_Credentials_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_Credentials_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_credentials_desc(inputs)
	return en_prompt_tips_credentials_desc(inputs)
});
export { prompt_tips_credentials_desc as "prompt_tips.credentials_desc" }